import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const STORAGE_KEY = '__i18n_missing_keys__'

function readMissing() {
    try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]')
    } catch {
        return []
    }
}

function writeMissing(list) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list))
}

function addMissingEntry(entry) {
    const list = readMissing()

    // Deduplicate by lng+ns+key
    const exists = list.some(
        (x) => x.lng === entry.lng && x.ns === entry.ns && x.key === entry.key,
    )
    if (!exists) {
        list.push({
            ...entry,
            firstSeenAt: new Date().toISOString(),
        })
        writeMissing(list)
    }
}

i18n.use(initReactI18next).init({
    ns: ['translation', 'public'],
    defaultNS: 'translation',
    lng: 'en',
    debug: process.env.NODE_ENV === 'development',
    keySeparator: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },

    // ✅ IMPORTANT
    saveMissing: true,
    // Optional: reduce noise in prod if you want
    // saveMissingTo: 'current', // default is 'fallback' depending on setup

    // Called when a key is missing (with saveMissing=true)
    missingKeyHandler: (lngs, ns, key, fallbackValue) => {
        const lng = Array.isArray(lngs) ? lngs[0] : lngs
        addMissingEntry({
            lng,
            ns,
            key,
            defaultValue: fallbackValue ?? '', // depends on how you call t()
            rta_value: `RTA_${key}`,
        })
    },

    // Optional: if you want the UI to display something nicer for missing keys
    // parseMissingKeyHandler: (key) => key,

    resources: {},
})

export default i18n
